import { IMaskGenerator } from "./imask-generator";

export class MaskUtils {

    private static PHONE_SMALL = '(99) 9999-9999';
    private static PHONE_BIG = '(99) 99999-9999';
    private static CPF = '999.999.999-99';
    private static CNPJ = '99.999.999/9999-99';
    private static STATE_INSCRITION = '999.99999-99'; //invalid 
    private static DATE = '99/99/9999';
    public static PLATE = 'AAA-9999';
    
    public static PHONE_MASK_GENERATOR: IMaskGenerator = {
        generateMask: () =>  MaskUtils.PHONE_SMALL,
    }

    public static DYNAMIC_PHONE_MASK_GENERATOR: IMaskGenerator = {
        generateMask: (value: string) => {
            return MaskUtils.hasMoreDigits(value, MaskUtils.PHONE_SMALL) ? 
                MaskUtils.PHONE_BIG : 
                MaskUtils.PHONE_SMALL;
        },
    }

    public static CPF_MASK_GENERATOR: IMaskGenerator = {
        generateMask: () => MaskUtils.CPF,
    }

    public static CNPJ_MASK_GENERATOR: IMaskGenerator = {
        generateMask: () => MaskUtils.CNPJ,
    }
    public static STATE_INSCRITION_MASK_GENERATOR: IMaskGenerator = {
        generateMask: () => MaskUtils.STATE_INSCRITION,
    }

    public static PERSON_MASK_GENERATOR: IMaskGenerator = {
        generateMask: (value: string) => {
            return MaskUtils.hasMoreDigits(value, MaskUtils.CPF) ? 
                MaskUtils.CNPJ : 
                MaskUtils.CPF;
        },
    }

    public static PLATE_MASK_GENERATOR: IMaskGenerator = {
        generateMask: () => MaskUtils.PLATE
    }

    public static DATE_MASK_GENERATOR: IMaskGenerator = {
        generateMask: () =>  MaskUtils.DATE,
    }

    private static hasMoreDigits(v01: string, v02: string): boolean {
        let d01 = this.onlyDigits(v01);
        let d02 = this.onlyDigits(v02);
        let len01 = (d01 && d01.length) || 0;
        let len02 = (d02 && d02.length) || 0;
        let moreDigits = (len01 > len02);
        return moreDigits;      
    }

    private static onlyDigits(value: string): string {
        let onlyDigits = (value != null) ? value.replace(/\D/g, '') : null;
        return onlyDigits;      
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/material/mask/mask-utils.ts